import { render } from "./EmailLog.vue?vue&type=template&id=38da06ac"
import script from "./EmailLog.vue?vue&type=script&lang=js"
export * from "./EmailLog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__